import React from 'react';
import ContentGrid from './ContentGrid';
import { getReadBlogPostIds } from './blogReadState';
export default function Blog(props) {
    return <ContentGrid {...props} readIds={getReadBlogPostIds()} />;
}
